/**
 * `/u/:handle` — the visitor view.
 *
 * One `RouteObject`, so the file is `.route.tsx` (singular). The handle is a
 * route param the page reads through `useParams`; no `loader` fetches here,
 * because a fetching loader would create a second cache with no shared
 * invalidation story.
 *
 * The route is guarded like every other authenticated surface: this address
 * sits behind the wall and carries `noindex, nofollow`, so a reader arriving
 * from an editorial byline on the public host meets the sign-in screen first
 * and lands back here afterwards.
 */
import type { RouteObject } from 'react-router-dom';

export const profilePublicRoute: RouteObject = {
  path: 'u/:handle',
  lazy: async () => {
    const { ProfilePublicPage } = await import('./ProfilePublic');
    return { Component: ProfilePublicPage };
  },
};
